import { addClass, removeClass, setElementText, hasClass } from "../utils/dom";

const initContactForm = element => {
  if (hasClass(element, "form-is-ready")) return;

  addClass(element, "form-is-ready");

  const info = type => {
    let alert_success = element.querySelector(".alert-success");
    alert_success &&
      (type === "success" ? alert_success.removeAttribute("hidden") : alert_success.setAttribute("hidden", true));

    let alert_error = element.querySelector(".alert-error");
    alert_error &&
      (type === "error" ? alert_error.removeAttribute("hidden") : alert_error.setAttribute("hidden", true));

    let alert_processing = element.querySelector(".alert-processing");
    alert_processing &&
      (type === "processing"
        ? alert_processing.removeAttribute("hidden")
        : alert_processing.setAttribute("hidden", true));
  };

  const send = e => {
    e.preventDefault();

    let companyControl = element.querySelector('[name="company"]');
    let nameControl = element.querySelector('[name="name"]');
    let phoneControl = element.querySelector('[name="phone"]');
    let emailControl = element.querySelector('[name="email"]');
    let messageControl = element.querySelector('[name="message"]');

    let company = companyControl ? companyControl.value : "";
    let name = nameControl ? nameControl.value : "";
    let phone = phoneControl ? phoneControl.value : "";
    let email = emailControl ? emailControl.value : "";
    let message = messageControl ? messageControl.value : "";

    const page_data = window._page_data || {};

    let params = {
      company,
      name,
      phone,
      email,
      message,
      ...page_data
    };

    let paramsURL = Object.keys(params)
      .map(function(k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      })
      .join("&");

    addClass(element, "processing");

    info("processing");

    const request = new XMLHttpRequest();
    request.open("POST", window._adminAjaxUrl ? window._adminAjaxUrl : "wp-admin/admin-ajax.php", true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (request.response && request.response.length) {
          if (request.response === "success") {
            info("success");
            if (companyControl) companyControl.value = "";
            if (nameControl) nameControl.value = "";
            if (phoneControl) phoneControl.value = "";
            if (emailControl) emailControl.value = "";
            if (messageControl) messageControl.value = "";
          } else if (request.response === "warning") {
            info("error");
            removeClass(element, "processing");
          } else if (request.response === "error") {
            info("error");
          }
        } else {
          info("error");
        }
      } else {
        info("error");
      }
    };
    request.onerror = e => {
      removeClass(element, "processing");
      info("error");
    };

    if (window.grecaptcha && params.recaptcha && params.recaptcha.length) {
      let action = "";
      action =
        action + (params.post_type && params.post_type.length ? (action.length ? "_" : "") + params.post_type : "");
      action =
        action + (params.post_name && params.post_name.length ? (action.length ? "_" : "") + params.post_name : "");
      action = action.replace(/[^a-zA-Z_]+/g, "");
      action = action.length ? action : "contact";

      window.grecaptcha.ready(function() {
        try {
          window.grecaptcha.execute(params.recaptcha, { action }).then(function(token) {
            if (token && token.length) {
              request.send("action=contact&" + paramsURL + "&token=" + encodeURIComponent(token));
            } else {
              info("error");
            }
          });
        } catch (e) {
          removeClass(element, "processing");
          info("error");
        }
      });
    } else {
      removeClass(element, "processing");
      info("error");
    }
  };

  element.addEventListener("submit", send);
};

const initContactForms = () => {
  const elements = document.querySelectorAll("form.mbr-form, .ptw-contact-form > form");
  if (elements) {
    Array.prototype.forEach.call(elements, element => {
      initContactForm(element);
    });
  }
};

export default initContactForms;
